// The user's interface choices (theme, language, density, sidebar groups) are applied by the
// shell at once and announced here; the account feature listens and saves them.
import type { PreferencesPatch } from "@cosmosai/shared";

type Listener = (patch: PreferencesPatch) => void;

const listeners = new Set<Listener>();

/** Calls the listener with each choice the user makes; returns the unsubscribe function. */
export function onPreferenceChosen(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Tells the listeners the user chose these values. */
export function announcePreference(patch: PreferencesPatch): void {
  for (const listener of listeners) listener(patch);
}
